import { getFormattedDate } from '@app/utils/date'

import { MONITORING_TASK_STATUS_TITLE } from '@app/api/constants'
import { dateFormat } from '@app/constants'

import type { MonitoringTaskLogsDto } from '@app/api/routes/monitoringTasks/dtos'
import type { LogItem } from '@app/drawers/ViewingLogsDrawer/ViewingLogs/types'

export const getMonitoringTaskLogsDataFromResponse = (response?: MonitoringTaskLogsDto[]): LogItem[] | undefined => {
  if (!response) return

  const rawData: MonitoringTaskLogsDto[] | undefined = response

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    title: MONITORING_TASK_STATUS_TITLE[dto.status],
    dateTime: getFormattedDate(dto.createdAt, dateFormat.DD_MM_YYYY_HH_mm),
    description: dto.taskId
  }))
}
